// @ts-nocheck
import * as Types from "../../../../types/types";

import type { IndexSelectionData } from "types/index_selection";
import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type IndexingEngineIssueQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  tableId: Types.Scalars["ID"]["input"];
  runId: Types.Scalars["ID"]["input"];
}>;

export type IndexingEngineIssueQuery = {
  __typename?: "GraphqlQuery";
  getSchemaTableIndexSelection: {
    __typename?: "IndexSelection";
    runAt: number;
    data: IndexSelectionData;
    isPrimaryInCluster?: boolean | null;
    scans: Array<{
      __typename?: "IndexSelectionScanDetail";
      id: string;
      whereExpression?: string | null;
      joinExpression?: string | null;
      combinedExpression: string;
      avgCallsPerMinute: number;
      avgCallsPerMinuteCluster?: number | null;
      parameterizedScanExpected?: boolean | null;
      queries: Array<{
        __typename?: "QuerySummaryStats";
        id: string;
        normalizedQuery: string;
        truncatedQuery: string;
        avgTime: number;
        callsPerMinute: number;
        pctOfTotal: number;
        databaseId: string;
        serverName: string;
      }>;
    }>;
  };
  getSchemaTableIndices: Array<{
    __typename?: "SchemaIndex";
    id: string;
    name: string;
    constraintDef?: string | null;
  }>;
};

export const IndexingEngineIssueDocument = gql`
  query IndexingEngineIssue($databaseId: ID!, $tableId: ID!, $runId: ID!) {
    getSchemaTableIndexSelection(runId: $runId) {
      runAt
      data
      isPrimaryInCluster
      scans {
        id
        whereExpression
        joinExpression
        combinedExpression
        avgCallsPerMinute
        avgCallsPerMinuteCluster
        parameterizedScanExpected
        queries {
          id
          normalizedQuery
          truncatedQuery
          avgTime
          callsPerMinute
          pctOfTotal
          databaseId
          serverName
        }
      }
    }
    getSchemaTableIndices(databaseId: $databaseId, schemaTableId: $tableId) {
      id
      name
      constraintDef
    }
  }
`;

/**
 * __useIndexingEngineIssueQuery__
 *
 * To run a query within a React component, call `useIndexingEngineIssueQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndexingEngineIssueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndexingEngineIssueQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      tableId: // value for 'tableId'
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useIndexingEngineIssueQuery(
  baseOptions: Apollo.QueryHookOptions<
    IndexingEngineIssueQuery,
    IndexingEngineIssueQueryVariables
  > &
    (
      | { variables: IndexingEngineIssueQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    IndexingEngineIssueQuery,
    IndexingEngineIssueQueryVariables
  >(IndexingEngineIssueDocument, options);
}
export function useIndexingEngineIssueLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IndexingEngineIssueQuery,
    IndexingEngineIssueQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    IndexingEngineIssueQuery,
    IndexingEngineIssueQueryVariables
  >(IndexingEngineIssueDocument, options);
}
// @ts-ignore
export function useIndexingEngineIssueSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IndexingEngineIssueQuery,
    IndexingEngineIssueQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  IndexingEngineIssueQuery,
  IndexingEngineIssueQueryVariables
>;
export function useIndexingEngineIssueSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IndexingEngineIssueQuery,
        IndexingEngineIssueQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  IndexingEngineIssueQuery | undefined,
  IndexingEngineIssueQueryVariables
>;
export function useIndexingEngineIssueSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IndexingEngineIssueQuery,
        IndexingEngineIssueQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    IndexingEngineIssueQuery,
    IndexingEngineIssueQueryVariables
  >(IndexingEngineIssueDocument, options);
}
export type IndexingEngineIssueQueryHookResult = ReturnType<
  typeof useIndexingEngineIssueQuery
>;
export type IndexingEngineIssueLazyQueryHookResult = ReturnType<
  typeof useIndexingEngineIssueLazyQuery
>;
export type IndexingEngineIssueSuspenseQueryHookResult = ReturnType<
  typeof useIndexingEngineIssueSuspenseQuery
>;
export type IndexingEngineIssueQueryResult = Apollo.QueryResult<
  IndexingEngineIssueQuery,
  IndexingEngineIssueQueryVariables
>;
